import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes, SlotsType } from 'vue'


export const edittableColumnDiyProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type EdittableColumnDiyProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnDiyProps>>>

export default defineComponent({
  name: 'OEdittableColumnDiy',
  inheritAttrs: false,
  props: edittableColumnDiyProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
